import _ from 'lodash';
import { HITLBase } from './HITLBase';
export class ContactRuleGroups extends HITLBase {
    static searchContactRuleGroups(options = {}) {
        const route = this.getBaseUrl(options);
        const params = _.omit(options, ['version', 'groupIdList', 'accountId']);
        const data = _.pick(options, 'groupIdList');
        return this.request({
            route,
            params,
            data,
        });
    }
    static createContactRuleGroup(options) {
        const route = this.getBaseUrl(options);
        const data = _.pick(options, ['name', 'rules']);
        return this.request({
            method: 'POST',
            route,
            data,
        });
    }
    static updateContactRuleGroup(options) {
        const route = this.getBaseUrl(options);
        const data = _.pick(options, ['groupId', 'name', 'rules']);
        return this.request({
            method: 'PUT',
            route,
            data,
        });
    }
    static deleteContactRuleGroup(options) {
        const route = this.getBaseUrl(options);
        const params = _.pick(options, ['groupId']);
        return this.request({
            method: 'DELETE',
            route,
            params,
        });
    }
}
ContactRuleGroups.MODULE_URL = 'contact-rule-groups';
//# sourceMappingURL=ContactRuleGroups.js.map